import React, { useEffect, useLayoutEffect, useState } from "react";
import { IntlProvider } from "react-intl";
import en_US from "../../../../locale/en_US.json";
import ko_KR from "../../../../locale/ko_KR.json";
import ar from "../../../../locale/ar.json";
import de_DE from "../../../../locale/de_DE.json";
import es from "../../../../locale/es.json";
import fil from "../../../../locale/fil.json";
import fr_CA from "../../../../locale/fr_CA.json";
import fr_FR from "../../../../locale/fr_FR.json";
import id_ID from "../../../../locale/id_ID.json";
import ja_JP from "../../../../locale/ja_JP.json";
import sv_SE from "../../../../locale/sv_SE.json";
import zh_CN from "../../../../locale/zh_CN.json";

const SUPPORTED = {
  "en-US": en_US,
  "de-DE": de_DE,
  "fr-CA": fr_CA,
  "fr-FR": fr_FR,
  "id-ID": id_ID,
  "ja-JP": ja_JP,
  "ko-KR": ko_KR,
  ko: ko_KR,
  "sv-SE": sv_SE,
  "zh-CN": zh_CN,
  ar,
  es,
  fil
};

/**
 *
 * @param {string} lang
 * @returns
 */
const importMessages = async lang => {
  let messages;
  try {
    const normalized = lang.replace("-", "_");
    messages = await import(`/${normalized}.json`);
    console.debug(`${lang}:messages`, messages);
    return messages;
  } catch (e) {
    console.debug("messages", messages);
    console.error(`ICS error below:`);
    console.error(e);
  }
};

export const Localizer = ({ locale = navigator.language, children }) => {
  const DEFAULT_LOCALE = "en-US";
  const [localeCode, setLocaleCode] = useState(locale);
  const [messages, setMessages] = useState(SUPPORTED[locale]);

  return (
    messages && (
      <IntlProvider
        messages={messages}
        locale={localeCode}
        defaultLocale={DEFAULT_LOCALE}
      >
        {children}
      </IntlProvider>
    )
  );
};
